/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Polish (Poland)
export default {
  'ai-mate.chat-error-banner.description': 'Zapisywana jest historia czatu z maksymalnie 30 dni.',
  'ai-mate.chat-error-banner.title': 'Rozpocznij nowy czat',
  'ai-mate.chat-error.description': 'Spróbuj <btn>załadować czat ponownie</btn>.',
  'ai-mate.chat-error.rate-limited-description': 'Osiągnięto maksymalną liczbę żądań. Spróbuj ponownie później.',
  'ai-mate.chat-error.rate-limited-title': 'Zbyt wiele żądań',
  'ai-mate.chat-error.rovo-inactive-description':
    'Wygląda na to, że nie włączono Rovo w witrynie. <link>Konfigurowanie Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo jest nieaktywne',
  'ai-mate.chat-error.title': 'Nie wiemy, co poszło nie tak',
  'ai-mate.main-chat.close-chat-button-label': 'Zamknij',
  'ai-mate.main-chat.maximize-chat-button-label': 'Pełny ekran',
  'ai-mate.main-chat.minimize-chat-button-label': 'Przywróć widok',
  'ai-mate.main-chat.new-chat-button-label': 'Nowość',
  'ai-mate.main-chat.new-chat-button-label-full-screen': 'Nowy czat',
  'conversation-assistant-button.label': 'Czat',
  'conversation-assistant-button.rovo-chat-label': 'Czat Rovo',
  'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Wyślij',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Zapytaj o to AI',
  'highlight-actions.rovo-chat-explain-option.text': 'Wyjaśnij',
  'highlight-actions.rovo-chat-explain-prompt':
    'Wyjaśnij ten tekst, formułując go na nowo i dodając dodatkowe szczegóły, ale użyj bardzo prostego języka i krótkich zdań oraz podaj przykłady lub definicje terminologii technicznej użytej w oryginalnym tekście.',
  'highlight-actions.rovo-chat-find-resources-option.text': 'Znajdź zasoby',
  'highlight-actions.rovo-chat-find-resources-prompt':
    'Znajdź w ramach wiedzy organizacyjnej tylko te zasoby, które potwierdzają podane stwierdzenia.',
  'highlight-actions.rovo-chat-give-examples-option.text': 'Podaj przykłady',
  'highlight-actions.rovo-chat-give-examples-prompt':
    'Podaj przykłady pochodzące z zasobów organizacyjnych lub ogólnodostępnej wiedzy. Jeśli nie ma odpowiednich zasobów, spróbuj podać metaforyczny przykład, który może pomóc komuś lepiej to zrozumieć.',
  'highlight-actions.rovo-chat-give-feedback-option.text': 'Przekaż opinię',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    'Przekaż opinię, sprawdzając poprawność tego tekstu. Skomentuj dobór słów, gramatykę i interpunkcję. Zachowaj pozytywne nastawienie i entuzjazm, ale zawsze podawaj przynajmniej jedną rzecz do poprawy lub zmiany.',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Zalecenia dotyczące czatu',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Otwórz czat',
  'highlight-actions.rovo-chat-summarize-option.text': 'Podsumuj',
  'highlight-actions.rovo-chat-summarize-prompt':
    'Wskaż najważniejsze zagadnienia z tego tekstu. Skoncentruj się na istotnych informacjach i pomiń niepotrzebne szczegóły. Podaj krótkie podsumowanie w jednym akapicie.',
  'highlight-actions.rovo-chat.button-text': 'Czat',
  'highlight-actions.rovo-chat.button-text-ask-in-chat': 'Zapytaj na czacie',
  'horizontal-scroll-container.scroll-left': 'Przewiń w lewo',
  'horizontal-scroll-container.scroll-right': 'Przewiń w prawo',
};
